module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel01_1280_1280_vi-3b9ba9e89d9da2abacd93c5f867e3620.jpg";